import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { OwnerPortalService } from './owner-portal.service';
import { OwnerWorkspaceService } from './owner-workspace.service';
import { DisplayDateValue, DisplayDateVariant, formatDisplayDate, normalizeDatePattern, validTimeZone } from '../../../../../shared-util/src/lib/date-time';
@Injectable({ providedIn: 'root' })
export class OwnerDateFormatService {
  private readonly api = inject(OwnerPortalService);
  private readonly workspace = inject(OwnerWorkspaceService);
  constructor() {
    if (isPlatformBrowser(inject(PLATFORM_ID))) this.api.getUserProfile().subscribe({ error: () => {} });
  }
  /** The zone dates are shown in: the person's profile zone, else the workspace's (null: the browser's). */
  timeZone(): string | null {
    return validTimeZone(this.api.userProfile()?.timeZone) || this.workspace.currentBranding()?.timeZone || null;
  }
  format(value: DisplayDateValue, variant: DisplayDateVariant = 'date', fallback = 'Not available'): string {
    const profile = this.api.userProfile(); const workspace = this.workspace.currentBranding();
    return formatDisplayDate(value, { dateFormat: normalizeDatePattern(profile?.preferences?.dateFormat) || workspace?.dateFormat,
      timeZone: validTimeZone(profile?.timeZone) || workspace?.timeZone, locale: profile?.locale || workspace?.locale,
      timeFormat: profile?.preferences?.timeFormat }, variant, fallback);
  }
}
